import React from "react";
import { useSelector } from "react-redux";
import { PrintableCertificate } from "../certficate/certificate";
import { formatCertificateDate } from "../../helpers/date.helper";

interface CertificateDownloadProps {
  user: any;
  userData: any;
  buttonClassName?: string;
}

export const CertificateDownload: React.FC<CertificateDownloadProps> = ({
  user,
  userData,
  buttonClassName,
}) => {
  const courseState = useSelector((state: any) => state.course);
  const userCertificates = courseState?.certificates || [];
  const currentCourseStatus = courseState?.data?.status;

  // Get the most recent certificate for download
  const getLatestCertificate = () => {
    debugger;
    if (currentCourseStatus === "pass") {
      return {
        status: "pass",
        userName:
          user?.name ||
          (userData?.first_name && userData?.last_name
            ? `${userData.first_name} ${userData.last_name}`
            : user?.email),
        state: userData?.state,
        completedDate: formatCertificateDate(courseState?.data?.last_completion),
      };
    }

    if (userCertificates?.length > 0) {
      // Filter certificates that have valid comp_date
      const validCertificates = userCertificates.filter(
        (cert) => cert.comp_date && !isNaN(new Date(cert.comp_date).getTime()),
      );

      if (validCertificates.length === 0) {
        return { status: "fail" };
      }

      // Sort by comp_date DESC (latest first)
      const latest = validCertificates.sort((a, b) => {
        const dateA = new Date(a.comp_date).getTime();
        const dateB = new Date(b.comp_date).getTime();
        return dateB - dateA;
      })[0];

      return {
        status: "pass",
        userName:
          user?.name ||
          (userData?.first_name && userData?.last_name
            ? `${userData.first_name} ${userData.last_name}`
            : user?.email),
        state: userData?.state,
        completedDate: formatCertificateDate(latest.comp_date),
      };
    }

    return null;
  };

  const certificateData = getLatestCertificate();

  if (!certificateData) {
    return null;
  }

  return (
      <PrintableCertificate
        courseStatus={certificateData.status}
        userName={certificateData.userName}
        state={certificateData.state}
        completedDate={certificateData.completedDate}
        hideIcon={true}
        className={buttonClassName || "pl-button--black"}
      />
    );
};
